var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2GroupPowerSupply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.93 30.38h8.24v2A8.13 8.13 0 0138 40.86 8.49 8.49 0 1142.22 25l-2 3.48A4.49 4.49 0 1038 36.86a4.12 4.12 0 003.76-2.49h-3.83v-3.99zm18.36 2A18.31 18.31 0 0140 50.55V69h-4V50.55a18.28 18.28 0 010-36.35V7h4v7.2a18.31 18.31 0 0116.29 18.18zm-4.57 0A13.71 13.71 0 1038 46.09a13.73 13.73 0 0013.72-13.71z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Group_Power_Supply.43eb4122.svg";
export { SvgA2GroupPowerSupply as ReactComponent };